import { render, staticRenderFns } from "./GiftSelection.vue?vue&type=template&id=d85603f0&scoped=true"
import script from "./GiftSelection.vue?vue&type=script&lang=js"
export * from "./GiftSelection.vue?vue&type=script&lang=js"
import style0 from "./GiftSelection.vue?vue&type=style&index=0&id=d85603f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d85603f0",
  null
  
)

export default component.exports